export default __webpack_public_path__ + "static/media/ic_attachment.0d806c32.svg";